import animateValue from "../../animateValue";

export default function(el) {
    if (!el.dataset.figure) return;

    const figure = parseInt(el.dataset.figure, 10);

    const updateInnerText = (element, currentValue) => {
        element.innerText = currentValue;
    }

    if(figure)
        animateValue(el, updateInnerText, 0, figure, 1500);
}